"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var loglevel_1 = __importDefault(require("loglevel"));
var Analytics_1 = __importDefault(require("../Analytics"));
var BasicTrackerAbstractImpl = /** @class */ (function () {
    function BasicTrackerAbstractImpl(options) {
        this._logger = null;
        this._options = options;
    }
    BasicTrackerAbstractImpl.prototype.getPlatformInstance = function () {
        return window[this._options.globalKeyForPlatform];
    };
    BasicTrackerAbstractImpl.prototype.getTrackerName = function () {
        if (this._options.trackerName !== undefined && this._options.trackerName !== null && this._options.trackerName.length !== 0) {
            return this._options.trackerName;
        }
        return null;
    };
    BasicTrackerAbstractImpl.prototype.getLogger = function () {
        if (this._logger === null) {
            if (this._options.logger === undefined) {
                this._options.logger = {};
            }
            if (this._options.logger.name === undefined || this._options.logger.name === null) {
                this._options.logger.name = Analytics_1.default.getInstance().getLoggerName(this.platformName);
            }
            this._logger = loglevel_1.default.getLogger(this._options.logger.name);
            if (this._options.logger.defaultLevel === undefined || this._options.logger.defaultLevel === null) {
                this._options.logger.defaultLevel = Analytics_1.default.getInstance().getLoggerDefaultLevel(this.platformName);
            }
            this._logger.setDefaultLevel(this._options.logger.defaultLevel);
        }
        return this._logger;
    };
    return BasicTrackerAbstractImpl;
}());
exports.default = BasicTrackerAbstractImpl;
